/**
 *
 * Asynchronously loads the component for Advisor
 *
 */

import { lazyLoad } from 'utils/loadable';

export const Advisor = lazyLoad(
  () => import('./index'),
  module => module.Advisor,
);
